import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import LiveForm from '../../components/form/live-form';

export default function LiveAdd() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Add Live Stream"}
                    is_main_page={false}
                />
                <LiveForm
                    mode={'add'}
                    button_title={'Add'}
                />
            </Container>
        </>
    )
}